import React, { useEffect, useState } from "react";
import moment from "moment";
import SearchBar from "../../../shared/SearchBar/SearchBar";
import Table, { TableBody, TableHeading } from "../../../shared/Table/Table";
import Empty from "../../../shared/Empty/Empty";
import PaginateButton from "../../../shared/PaginateButton/PaginateButton";

import {
  RootStore,
  useAppDispatch,
  useAppSelector,
} from "../../../store/store";
import { getContactMessages } from "../../../store/features/AdminPanel/Subscribers/SubscriberApi";
import {
  contactMessagesTablePaginate,
  searchContactMessages,
} from "../../../store/features/AdminPanel/Subscribers/SubscriberSlice";
import "./index.scss";
import Loader from "../User/UserAllTabs/Loader";


const TrainingAGroupComp = () => {
  const [searchText, setSearchText] = useState("");
  const dispatch = useAppDispatch();

  const contactMessageState: any = useAppSelector((store: RootStore) => {
    return store.SubscriberSlice;
  });

  const handlePagination = (num: number) => {
    dispatch(contactMessagesTablePaginate(num));
  };
  useEffect(() => {
    dispatch(getContactMessages());
  }, []);

  useEffect(() => {
    dispatch(searchContactMessages(searchText));
  }, [searchText]);

  return (
    <div className="mt-7">
      <div className="subscribers-bottom ">
        <div className="sh-table-top">
          <div className="left">Group Users</div>
          <div className="right subscriber__table__head__right__section">
            <div className="searchbar__wrapper">
              {" "}
              <SearchBar value={searchText} setValue={setSearchText} />
            </div>
          </div>
        </div>
        <div className="subscriber__talbe__section">
          <Table
            heading={
              <TableHeading>
                <th>Name</th>
                <th>Email Address</th>
                <th>Message</th>
                <th className="">Mailed At</th>
                <th className="">Course</th>
                <th className="hide__text">.</th>
              </TableHeading>
            }
          >
            <TableBody>
              {
                !contactMessageState.loading &&
              contactMessageState?.contact_messages_data &&
                contactMessageState?.contact_messages_data.map((item: any) => {
                  return (
                    <tr key={item}>
                      <td className="subscriber_name">{item?.name}</td>
                      <td className="subscriber_name">{item?.email}</td>
                      <td className="subscriber_name">
                        <div className="contact__message__wrapper">
                          <p>
                            {item?.message.length > 30
                              ? `${item?.message.substring(0, 30)}... `
                              : item?.message}
                          </p>
                          {item?.message.length > 30 && (
                            <span>{item?.message}</span>
                          )}
                        </div>
                      </td>
                      <td className="">
                        {moment(item?.created_at).format("DD/MM/YYYY")}
                      </td>

                      <td className="">{item?.course}</td>
                      <td className="hide__text">.</td>
                    </tr>
                  );
                })}
            </TableBody>
          </Table>

          {contactMessageState?.contact_messages_data.length === 0 && !contactMessageState.loading&& (
            <div className="mt-5 handle__empty__container__div">
              <Empty emptyText="It seems empty." custombg={true} />
            </div>
          )}
            {
                      contactMessageState.loading && !contactMessageState.req_success && (
                              <Loader/>
                      )
                      }
        </div>
      </div>
      {/* <div className="pagination__section">
        <PaginateButton
          paginate={handlePagination}
          totalRows={contactMessageState?.all_contact_data?.length}
        />
      </div> */}
    </div>
  );
};

export default TrainingAGroupComp;
